
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import IconButton from '@/components/shared/suites/IconButton.vue';

@Component<CreditRowItem>({
	components: {
		IconButton
	}
})
export default class CreditRowItem extends Vue {
	@Prop({ type: Object, required: true, default: () => {} }) private credit!: App8Credit;

	private get creditStatus(): 'expired' | 'empty' | 'valid' {
		if (this.credit.expiry && this.credit.expiry <= DateTime.now()) {
			return 'expired';
		}
		if (this.credit.balance <= 0) {
			return 'empty';
		}
		return 'valid';
	}

	/**
	 * Open modal to edit the credit.
	 *
	 * @param {App8Credit} credit - The credit to edit
	 * @return {void}
	 */
	private editCredit(credit: App8Credit): void {
		this.$emit('edit-click', credit);
	}

}
